
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Component } from "vue-property-decorator";
import BaseInternalChartValorization from "@/components/pages/valorizations/internal/observatory/BaseInternalChartValorization.vue";

@Component
export default class ThreatModesChart extends BaseInternalChartValorization {
  protected title = "Statuts de menace";
  protected subTitle = "Observatoire Flore";
  protected description = "";

  drawData() {
    let count = this.data.reduce((prev, cur) => prev + cur["count"], 0);

    this.data = count > 0 ? this.data : [];

    this.drawChart();

    this.series = this.chart.series.push(new am4charts.PieSeries());

    this.series.dataFields.value = "count";
    this.series.dataFields.category = "status";

    // Let's cut a hole in our Pie chart the size of 30% the radius
    this.chart.innerRadius = am4core.percent(30);

    // Put a thick white border around each Slice
    this.series.slices.template.stroke = am4core.color("#fff");
    this.series.slices.template.strokeWidth = 2;
    this.series.slices.template.strokeOpacity = 1;
    // change the cursor on hover to make it apparent the object can be interacted with
    this.series.slices.template.cursorOverStyle = [
      {
        property: "cursor",
        value: "pointer"
      }
    ];

    // this.series.slices.template.fill = am4core.color("#dc3545"); // green fill

    // this.series.colors.list = [
    //     am4core.color("#6c757d"),
    //     am4core.color("#dc3545"),
    //     am4core.color("#fd7e14"),
    //     am4core.color("#28A743"),
    // ];

    this.series.colors.list = [
      am4core.color("#c6c7c8"),
      am4core.color("#f29400"),
      am4core.color("#ffd542"),
      am4core.color("#99b034")
    ];

    this.series.labels.template.text = "{value.value} espèce";

    this.series.legendSettings.labelText = "{status}";
    this.series.legendSettings.valueText = "{count}";
    this.series.legendSettings.valueText = "{valueY.close}";
    this.series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
    this.series.labels.template.adapter.add("text", function(text, target) {
      console.log("text", text);
      console.log("target", target);

      let response: string;
      switch (target.dataItem.value) {
        case 0:
          response = "";
          break;

        case 1:
          response = "1 espèce";
          break;

        default:
          response = text + "s";
          break;
      }

      return response;
    });

    // Create a base filter effect (as if it's not there) for the hover to return to
    let shadow = this.series.slices.template.filters.push(
      new am4core.DropShadowFilter()
    );
    shadow.opacity = 0;

    // Create hover state
    let hoverState = this.series.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

    // Slightly shift the shadow and make it more prominent on hover
    let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
    hoverShadow.opacity = 0.7;
    hoverShadow.blur = 5;

    // Add a legend
    this.chart.legend = new am4charts.Legend();
    this.chart.legend.name = "label";
  }
}
